import { useState, useEffect, useRef, useCallback } from "react";
import { getLoadEmpPayrollDetails } from "../api";

export const useFetchPayrollDetails = (payrollId, refreshKey) => {
  const [activePage, setActivePage] = useState("attention");
  const [matchedRows, setMatchedRows] = useState([]);
  const [attentionRows, setAttentionRows] = useState([]);
  const [payrollTotals, setPayrollTotals] = useState({ matched: null, attention: null });
  const [attentionCount, setAttentionCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const [totalRecords, setTotalRecords] = useState(0);
  const [dataLoading, setDataLoading] = useState(false);
  const [tabTrigger, setTabTrigger] = useState(0);

  const handleTabChange = useCallback((tab) => {
    if (tab) {
      setActivePage(tab);
    }
    setPage(0);
    setTabTrigger((prev) => prev + 1);
  }, []);

  const rowsPerPageRef = useRef(rowsPerPage);
  useEffect(() => {
    rowsPerPageRef.current = rowsPerPage;
  }, [rowsPerPage]);

  useEffect(() => {
    setPage(0);
  }, [payrollId, refreshKey]);

  useEffect(() => {
    const fetchData = async () => {
      if (!payrollId) return;
      setDataLoading(true);
      try {
        const response = await getLoadEmpPayrollDetails(payrollId, page + 1);
        const details = response?.PayEmpDetails || [];

        const matched = [];
        const attention = [];
        debugger;
        const isMatchedStatus = (status) => {
          const normalized = String(status || "").trim().toLowerCase();
          return normalized === "completed" || normalized === "matched";
        };

        const apiMaxRows = Number(details?.[0]?.MaxRows) || null;
        const maxRows = apiMaxRows || rowsPerPageRef.current || 40;
        const apiTotalRecords = Number(details?.[0]?.TotalRecords);
        const totalCount =
          !isNaN(apiTotalRecords) && apiTotalRecords > 0
            ? apiTotalRecords
            : Number(response?.TotalRecords || response?.totalRecords || details.length) || 0;

        details.forEach((item) => {
          const isMatched = isMatchedStatus(item.MappingStatus);
          const isVoided =
            item.IsVoided === true || String(item.IsVoided).toLowerCase() === "true";
          const row = {
            name: item.EmployeeName,
            department: item.Department,
            jobTitle: item.JobTitle,
            profitCenter: item.ProfitCenter || "",
            hrs: item.TotalHours ?? item.Hours ?? 0,
            grossPay: item.Wages,
            additions: item.Additions,
            deductions: item.Deductions,
            eeTaxes: item.EmployeeTaxes,
            netPay: item.NetPay,
            erTaxes: item.EmployerTaxes,
            view: isMatched ? "Matched" : "Unmapped",
            isVoided: isVoided,
            importedName: item.ImportedEmployeeName || null,
            raw: item,
          };
          if (isMatched) matched.push(row);
          else attention.push(row);
        });

        setMatchedRows(matched);
        setAttentionRows(attention);

        const anyItem = details?.[0] || {};
        const apiAttentionCount = anyItem.AttentionNeededCount;
        const apiCompletedCount = anyItem.CompletedCount;

        const parsedAttentionCount =
          apiAttentionCount !== undefined && apiAttentionCount !== null && !isNaN(Number(apiAttentionCount))
            ? Number(apiAttentionCount)
            : 0;

        const parsedCompletedCount =
          apiCompletedCount !== undefined && apiCompletedCount !== null && !isNaN(Number(apiCompletedCount))
            ? Number(apiCompletedCount)
            : 0;

        setAttentionCount(parsedAttentionCount);
        setCompletedCount(parsedCompletedCount);

        if (parsedAttentionCount === 0 && parsedCompletedCount > 0) {
          setActivePage("matched");
        }

        const getNum = (val) => (val !== undefined && val !== null ? val : 0);
        const extractTotals = (item) => {
          if (!item) return null;
          return {
            hrs: getNum(item.PayrollTotalHours),
            grossPay: getNum(item.TotalWages),
            additions: getNum(item.TotalAdditions),
            deductions: getNum(item.TotalDeductions),
            eeTaxes: getNum(item.TotalEmployeeTaxes),
            netPay: getNum(item.TotalNetPay),
            erTaxes: getNum(item.TotalEmployerTaxes),
          };
        };
        debugger;
        const attentionItem = details.find((item) => !isMatchedStatus(item.MappingStatus));
        const completedItem = details.find((item) => isMatchedStatus(item.MappingStatus));

        const attentionTotalsFromApi = extractTotals(attentionItem);
        const completedTotalsFromApi = extractTotals(completedItem);
        const zeroTotals = { hrs: 0, grossPay: 0, additions: 0, deductions: 0, eeTaxes: 0, netPay: 0, erTaxes: 0 };

        setPayrollTotals((prev) => ({
          attention:
            parsedAttentionCount === 0
              ? zeroTotals
              : (attentionTotalsFromApi || zeroTotals),
          matched:
            parsedCompletedCount === 0
              ? zeroTotals
              : (completedTotalsFromApi || zeroTotals),
        }));
        setRowsPerPage(maxRows);
        setTotalRecords(totalCount);
      } catch (error) {
        console.error("Error fetching employee payroll details:", error);
      } finally {
        setDataLoading(false);
      }
    };
    fetchData();
  }, [payrollId, refreshKey, page, tabTrigger]);

  return {
    activePage,
    setActivePage,
    handleTabChange,
    matchedRows,
    attentionRows,
    payrollTotals,
    attentionCount,
    completedCount,
    page,
    setPage,
    rowsPerPage,
    totalRecords,
    dataLoading
  };
};
